import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../../Localization/Translation";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailedRequest from "./DetailedRequest/DetailedRequest.js";

const LaundryJoinReq = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (laundryId) => {
    setShow(true);
  };

  const acceptReq = (id) => {
    console.log(document.getElementById(id));
    document.getElementById(id).style.display = "none";
  };
  const rejectReq = (id) => {
    console.log(document.getElementById(id));
    document.getElementById(id).style.display = "none";
  };

  var LaundJoinReqs = [
    {
      id: 1,
      name: "النظافة",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 2,
      name: "الأمين",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 3,
      name: "دوف",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 4,
      name: "السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
  ];
  let d = "-1";
  var LaundJoinReqsList = LaundJoinReqs.map((Req) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "request-card row animate__animated animate__fadeInLeft animate__delay-" +
          d +
          "s"
        }
        dir="auto"
        key={Req.id}
        id={Req.id}
      >
        <div
          className="col-md-5 request-card-col main-data-request-card-col"
          dir="auto"
        >
          <div className="header-join-req-card">
            <i className="fa fa-building" aria-hidden="true"></i>
            <span>{translate("laundry-name", locale)}:</span>
            <span>{Req.name}</span>
          </div>
          <div className="date-join-req-card">
            <i className="fa fa-calendar" aria-hidden="true"></i>
            <span>{translate("date-of-request", locale)}:</span>
            <span>{Req.date}</span>
          </div>
        </div>
        <div className="col-md request-card-col detail-btn-request-card-col">
          <button className="btn btn-primary" onClick={handleShow}>
            {translate("detail-request-button", locale)}
          </button>
        </div>
        <div className="col request-card-col approval-request-card-col">
          <button className="btn btn-primary" onClick={() => acceptReq(Req.id)}>
            <i className="fa fa-check" aria-hidden="true"></i>
            {translate("accept-request", locale)}
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => rejectReq(Req.id)}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            {translate("reject-request", locale)}
          </button>
        </div>
      </div>
    );
  });

  return (
    <div className="DeliveryJoinReq-component">
      {LaundJoinReqsList}

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Header className="modal-header">
          {translate("detail-request-button", locale)}
        </Modal.Header>
        <Modal.Body>
          <DetailedRequest />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button variant="secondary" onClick={handleClose}>
            {translate("modal-close-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LaundryJoinReq;
